import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import {FileUploadSource} from 'sources/files/FileUploadSource';
import {List} from 'immutable';
import {SearchResult, Field} from 'records/Search';
import LibraryActions from 'actions/library/LibraryActions';

function transformSearchResults({data}) {
  return {
    ...data,
    fields: List(data.fields.map(field => new Field(field))),
    results: List(data.results.map(result => new SearchResult(result))),
  };
}

class FileUploadActions {
  constructor() {
    this.generateActions(
      'updateVotes',
      'setVote',
      ...generateAsyncActions('findFilesById', 'getFileInfo')
    );
  }

  findFilesById(ids) {
    return dispatch => {
      dispatch(ids);
      return FileUploadSource.findFilesById(ids)
        .then(resp => {
          LibraryActions.getInfoAboutFiles.defer(ids);
          return resp;
        })
        .then(resp => transformSearchResults(resp))
        .then(this.findFilesByIdSuccess, this.findFilesByIdError);
    };
  }

  getFileInfo(id) {
    return dispatch => {
      dispatch();
      return FileUploadSource.getFileInfo(id).then(this.getFileInfoSuccess, this.getFileInfoError);
    };
  }
}

export default alt.createActions(FileUploadActions);
